module.exports = require('./decorateLocation')
